import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";

const DataTableTransfertsEntrePayementInformations = ({ data, title }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const { SearchBar } = Search;


  function buttonPlusFormatter(cell, row) {
    return (
      <span style={{ display: "flex", justifyContent: "center" }}>
        <button
          style={{ width: 40 }}
          className="btn bg-black btn-sm"
          onClick={() => {
            sessionStorage.setItem("infoId", row.id);
            navigate('/transfertEntreComptesPusInfo')

          }}
        >
          <i className="fas fa-eye"></i>
        </button>
      </span>
    );
  }

  // Table columns
  const columns = [
    {
      dataField: "ref-year ",
      text: "Référence",
      headerAlign: "center",
      headerStyle: { width: "10%" },
      formatter: (cell, row) => {
        switch (row.typePayement) {
          case "Espéce":
            return `${row.ref}-${row.year}`;
          case "En ligne":
            return `${row.TPE}-${row.ref}`;
          case "Chéque/Traites":
            return `${row.codeCheque}`
          case "Carte Cadeau":
            return `${row.ref}`;
          default:
            return `${row.numVirement}`;
        }
      },
      align: "center",
    },
    {
      dataField: "typePayement",
      text: "type de payment",
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "amountPayed",
      text: "Montant Payé",
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "typePayementValidation",
      text: "Type de Paiement Validation",
      headerAlign: "center",
      formatter: (cell, row) => {
        switch (row.typePayementValidation) {
          case "none":
            return `Non rapproché`;
          case "accept":
            return `Accepté`;
          case "refuse-def":
            return `Rejeté définitivement`
          case "refuse":
            return `Rejeté`;
          default:
            return `-   align: "center",`;
        }
      },
      align: "center",
    },
    {
      dataField: "amountPayed",
      text: "Compte Bancaire",
      headerAlign: "center",
      formatter: (cell, row) => {
        return `${row?.banqueAccount?.bankAccountNumber}-${row?.banqueAccount?.name}`
      },
      align: "center",
    },
  ];


  return (
    <div className="card card-dark">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        {/* {stateDocument()} */}
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="ref"
          data={data}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <SearchBar {...props.searchProps} placeholder="Search..." />
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
                striped
                hover
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>

  );
};

export default DataTableTransfertsEntrePayementInformations;
